import { extendTheme } from '@chakra-ui/react';
import Accordion from './Accordion';
import Button from './Button';
import Modal from './Modal';
import Input from './Input';
import Select from './Select';
import Skeleton from './Skeleton';
import Text from './Text';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        position: 'static',
      },
      svg: {
        // Use SVG default display
        display: 'inline',
      },
      ':not(.chakra-do-not-set-collapse) > .chakra-collapse': {
        overflow: 'initial !important',
      },
    },
  },
  breakpoints: {
    sm: '768px',
    md: '992px',
  },
  components: {
    Accordion,
    Button,
    Modal,
    Input,
    Select,
    Skeleton,
    Text,
  },
});

export default theme;
